export default __webpack_public_path__ + "static/media/Chat-Alert.5fb2af2e.wav";